import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  Text,
  IconButton,
  useToast,
  Flex,
  VStack,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useCartStore from '../../../../store/cartStore';
import { AiOutlineDelete, AiOutlineShoppingCart, AiOutlineArrowRight } from 'react-icons/ai';
import { CartContext } from '../../../../context/cart';
import { Divider, Badge, Tooltip } from '@chakra-ui/react';

export const TestCard = ({ test, index }) => {
  const navigate = useNavigate();
  const { addToCartPlans, removeFromCart, cartPlans } = useContext(CartContext);
  const { removeItem } = useCartStore();
  const [loading, setLoading] = useState();
  const toast = useToast();
  const [addTocart, setAddToCart] = useState();

  useEffect(() => {
    if (test && cartPlans) {
      setAddToCart(cartPlans.some(item => item._id === test._id));
    }
  }, [cartPlans, test]);

  return (
    <Card
      width={'100%'}
      height={'full'}
      borderRadius={20}
      variant={'elevated'}
      transition={'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'}
      border={'1px solid'}
      borderColor={'gray.100'}
      overflow="hidden"
      bg="white"
      _hover={{
        transform: 'translateY(-10px)',
        boxShadow: '2xl',
        borderColor: 'teal.200',
      }}
      role="group"
    >
      <CardBody p={6}>
        <Stack spacing={4}>
          <Flex justifyContent="space-between" alignItems="flex-start">
            <Box
              p={3}
              borderRadius="16px"
              bg="teal.50"
              color="teal.600"
              transition="all 0.3s"
              _groupHover={{ bg: 'teal.500', color: 'white' }}
            >
              <AiOutlineShoppingCart size={24} />
            </Box>
            <Badge colorScheme="teal" variant="subtle" borderRadius="full" px={3} py={1}>
              Popular
            </Badge>
          </Flex>

          <Stack spacing={2}>
            <Heading
              fontSize={['lg', 'xl']}
              fontWeight="bold"
              color="gray.800"
              lineHeight="shorter"
              onClick={() => navigate(`/test?testId=${test._id}`)}
              _hover={{ color: 'teal.600', cursor: 'pointer' }}
              noOfLines={2}
              height="2.8em"
            >
              {test?.name}
            </Heading>
            <Text fontSize="sm" color="gray.500" noOfLines={3}>
              {test?.description}
            </Text>
          </Stack>

          <Divider borderColor="gray.100" />

          <Flex justifyContent="space-between" alignItems="center">
            <VStack align="start" spacing={0}>
              <Text fontSize="xs" fontWeight="bold" color="gray.400" textTransform="uppercase">
                Starting at
              </Text>
              <Heading fontSize="2xl" color="teal.600" fontWeight="extrabold">
                ₹{test?.price}
              </Heading>
            </VStack>

            <Tooltip label="View Details" placement="top" hasArrow>
              <IconButton
                variant="ghost"
                colorScheme="teal"
                aria-label="See details"
                borderRadius="full"
                icon={<AiOutlineArrowRight />}
                onClick={() => navigate(`/test?testId=${test._id}`)}
              />
            </Tooltip>
          </Flex>
        </Stack>
      </CardBody>

      <CardFooter p={0} bg="gray.50" borderTop="1px solid" borderColor="gray.100">
        {addTocart ? (
          <Flex width="full">
            <Button
              flex={1}
              height="3.5rem"
              borderRadius={0}
              leftIcon={<AiOutlineShoppingCart />}
              colorScheme="teal"
              variant="solid"
              onClick={() => navigate('/cart')}
              _hover={{ bg: 'teal.600' }}
            >
              Checkout Now
            </Button>
            <IconButton
              aria-label="Remove from cart"
              icon={<AiOutlineDelete />}
              height="3.5rem"
              width="3.5rem"
              borderRadius={0}
              colorScheme="red"
              variant="ghost"
              onClick={() => {
                removeItem(test._id);
                removeFromCart(test);
                toast({
                  title: 'Removed from cart',
                  status: 'info',
                  isClosable: true,
                  duration: 3000,
                  position: 'top',
                });
              }}
            />
          </Flex>
        ) : (
          <Button
            width="full"
            height="3.5rem"
            borderRadius={0}
            bg="teal.600"
            color="white"
            fontSize="md"
            fontWeight="bold"
            leftIcon={<AiOutlineShoppingCart />}
            isLoading={loading}
            onClick={() => {
              setLoading(true);
              addToCartPlans(test);
              setLoading(false);
              toast({
                title: 'Added to cart!',
                status: 'success',
                isClosable: true,
                duration: 3000,
                position: 'top',
              });
            }}
            _hover={{
              bg: 'teal.700',
              _after: {
                width: 'full',
              },
            }}
            _active={{ bg: 'teal.800' }}
            transition="all 0.3s"
          >
            Add to Cart
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};
